var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.question.cssClasses.root,
      style: {
        width: _vm.question.renderedCanvasWidth,
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.question.needShowPlaceholder(),
              expression: "question.needShowPlaceholder()",
            },
          ],
          class: _vm.question.cssClasses.placeholder,
        },
        [
          _c("survey-string", {
            attrs: { locString: _vm.question.locRenderedPlaceholder },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", [
        _vm.question.backgroundImage
          ? _c("img", {
              class: _vm.question.cssClasses.backgroundImage,
              style: {
                width: _vm.question.renderedCanvasWidth,
              },
              attrs: { src: _vm.question.backgroundImage },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("canvas", {
          class: _vm.question.cssClasses.canvas,
          attrs: { tabindex: "-1" },
          on: {
            blur: function (e) {
              _vm.question.onBlur(e)
            },
          },
        }),
      ]),
      _vm._v(" "),
      _vm.question.canShowClearButton
        ? _c("div", { class: _vm.question.cssClasses.controls }, [
            _c(
              "button",
              {
                class: _vm.question.cssClasses.clearButton,
                attrs: {
                  type: "button",
                  title: _vm.question.clearButtonCaption,
                },
                on: {
                  click: function () {
                    _vm.question.clearValue(true)
                  },
                },
              },
              [
                !_vm.question.cssClasses.clearButtonIconId
                  ? _c("span", [_vm._v("✖")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.question.cssClasses.clearButtonIconId
                  ? _c("sv-svg-icon", {
                      attrs: {
                        iconName: _vm.question.cssClasses.clearButtonIconId,
                        size: "auto",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.question.showLoadingIndicator
        ? _c(
            "div",
            { class: _vm.question.cssClasses.loadingIndicator },
            [_c("sv-loading-indicator")],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }